import { render, staticRenderFns } from "./moduleLayout.vue?vue&type=template&id=49e1a2f8&"
var script = {}
import style0 from "./moduleLayout.vue?vue&type=style&index=0&id=49e1a2f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports